import { motion } from "framer-motion";
import { CalendarDays, Repeat, Wallet } from "lucide-react";
import { Reveal, Kicker, SectionTitle } from "./motion";

const CARDS = [
  { icon: CalendarDays, t: "Procura o ano inteiro", p: "Volta às aulas, datas comemorativas, alfabetização, reforço: sempre tem alguém precisando de material.", c: "bg-sun", span: "lg:col-span-7" },
  { icon: Repeat, t: "Venda o mesmo kit várias vezes", p: "Você monta uma vez e pode vender para quantas pessoas quiser.", c: "bg-rose text-white", span: "lg:col-span-5" },
  { icon: Wallet, t: "Sem custo a cada venda", p: "Não tem estoque, gráfica nem frete. Você não gasta nada para entregar.", c: "bg-plum text-white", span: "lg:col-span-12" },
];

export const Opportunity = () => (
  <section className="bg-paper py-20 sm:py-28" data-testid="opportunity-section">
    <div className="mx-auto max-w-6xl px-5">
      <div className="grid gap-6 lg:grid-cols-12 lg:items-end">
        <Reveal className="lg:col-span-7">
          <Kicker>A oportunidade</Kicker>
          <SectionTitle className="mt-5 text-ink">Por que vender <span className="hl-mark">material pedagógico</span>?</SectionTitle>
        </Reveal>
        <Reveal className="lg:col-span-5" delay={0.1}>
          <p className="text-base text-ink/75 sm:text-lg">É um produto que nunca sai de moda: sempre tem criança aprendendo, e sempre tem alguém procurando atividades novas.</p>
        </Reveal>
      </div>
      <div className="mt-12 grid gap-4 lg:grid-cols-12">
        {CARDS.map((c, i) => (
          <Reveal key={c.t} delay={i * 0.08} className={c.span}>
            <motion.div whileHover={{ y: -6 }} transition={{ type: "spring", stiffness: 300, damping: 20 }}
              className={`flex h-full flex-col justify-between gap-10 rounded-[32px] p-8 sm:p-10 ${c.c}`} data-testid={`opportunity-card-${i}`}>
              <c.icon className="h-10 w-10" strokeWidth={1.8} />
              <div>
                <h3 className="font-display text-2xl font-extrabold leading-tight sm:text-3xl">{c.t}</h3>
                <p className="mt-3 max-w-xl text-base opacity-90">{c.p}</p>
              </div>
            </motion.div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
